var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spin_parent"},[_c('Table',{attrs:{"size":"small","loading":_vm.spin,"disabled-hover":true,"columns":_vm.columns,"data":_vm.data}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }